module.exports = __webpack_public_path__ + "img/5.a848138f.jpg";